import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import Divider from '@adsk/alloy-react-divider';
import {
  dividerStyle,
  trialMessageTitleStyle,
  trialMessageTextStyle,
  trialMessagesWrapper,
} from './style';

const OfferingTrialMessage = ({ member, subscriptionMessage }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  if (!member || !subscriptionMessage) return null;
  return (
    <div css={trialMessagesWrapper}>
      <Divider style={dividerStyle} />
      <div style={trialMessageTitleStyle}>
        {T.translate('MEMBER_SUBSCRIPTION_TRIAL_TITLE')}
      </div>
      <div style={trialMessageTextStyle}>
        {T.translate(subscriptionMessage.textKey, {
          days: subscriptionMessage.daysRemaining,
          member,
        })}
      </div>
    </div>
  );
};

OfferingTrialMessage.propTypes = {
  member: PropTypes.string,
  subscriptionMessage: PropTypes.shape({
    daysRemaining: PropTypes.number,
    textKey: PropTypes.string,
  }),
};

OfferingTrialMessage.defaultProps = {
  member: '',
  subscriptionMessage: null,
};

export default OfferingTrialMessage;
